import React from 'react';
import FigmaBadge from '../Elements/FigmaBadge';

// One row of the Client page's Pricing History grid: a year, split by the fields the user chose, with its invoiced
// evaluations and client fee. The amounts are in the row's Currency: the currency they were invoiced in, or USD.
// A field the rows are not split by comes back empty and its column is hidden. Each column's orderById is the name
// the server sorts by.
export default class ClientPricingHistoryItem {
  constructor(item) {
    if (item === undefined) {
      this.Year = '';
      this.IsYearToDate = false;
      this.Client = '';
      this.Industry = '';
      this.ServiceType = '';
      this.FieldworkOffice = '';
      this.Country = '';
      this.Currency = '';
      this.InvoicedEvaluations = '';
      this.ClientFee = '';
      this.FeePerEvaluation = '';
      return;
    }
    this.Year = item.year;
    this.IsYearToDate = item.isYearToDate === true;
    this.Client = item.client ?? '';
    this.Industry = item.industry ?? '';
    this.ServiceType = item.serviceType ?? '';
    this.FieldworkOffice = item.fieldworkOffice ?? '';
    this.Country = item.country ?? '';
    this.Currency = item.currency ?? '';
    this.InvoicedEvaluations = item.invoicedEvaluations;
    this.ClientFee = item.clientFee;
    this.FeePerEvaluation = item.feePerEvaluation;
  }

  // The rows have no id of their own, and nothing opens a detail for them.
  static NameOfTheIdField() {
    return '';
  }

  static nameOfTheItemDetailList() {
    return 'Pricing History';
  }

  static MoneyFields = ['ClientFee', 'FeePerEvaluation'];
  static Currency() {
    return 'Currency';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [];

  // The current year is still in progress, so its volume is partial.
  static getYearCellContent(item) {
    if (!item.IsYearToDate) return item.Year;
    return (
      <>
        {item.Year}{' '}
        <FigmaBadge
          variant='progress'
          label='YTD'
          tooltip='Year to date'
        />
      </>
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Year', orderById: 'Year', data: (item) => ClientPricingHistoryItem.getYearCellContent(item) },
      { label: 'Client', orderById: 'Client', data: 'Client' },
      { label: 'Industry', orderById: 'Industry', data: 'Industry' },
      { label: 'Service Type', orderById: 'ServiceType', data: 'ServiceType' },
      { label: 'Fieldwork Office', orderById: 'FieldworkOffice', data: 'FieldworkOffice' },
      { label: 'Country', orderById: 'Country', data: 'Country' },
      {
        label: 'Invoiced Evaluations',
        orderById: 'InvoicedEvaluations',
        data: 'InvoicedEvaluations',
        className: 'text-right',
      },
      { label: 'Client Fee', orderById: 'ClientFee', data: 'ClientFee', className: 'text-right' },
      { label: 'Fee per Evaluation', orderById: 'FeePerEvaluation', data: 'FeePerEvaluation', className: 'text-right' },
    ];
  }
}
